module.exports = __webpack_public_path__ + "static/media/food-7.fd49b7d4.jpg";